<div class="toggle-checkbox-wrapper">
  <div
    *ngIf="labelInfo && title"
    class="toggle-checkbox-title"
    nz-tooltip
    [nzTooltipTitle]="labelInfo"
    nzOverlayClassName="toggle-checkbox-overlay"
  >
    {{ title }}
  </div>

  <div *ngIf="!labelInfo" class="toggle-checkbox-title">
    {{ title }}
  </div>

  <label
    nz-checkbox
    [(ngModel)]="checkboxValue"
    (ngModelChange)="handleCheckboxChange($event)"
    [disabled]="disabled"
    class="toggle-checkbox"
    >{{ label }}</label
  >
</div>
